import { toRadian } from '../utils/string.utilts';
import { LayoutBase } from './LayoutBase';

export default class extends LayoutBase {
  getSize(): { width: number; height: number } {
    const { index } = this.getImageParams();
    const { imgEl } = this.getImageEl(index) ?? {};
    const { _scale = 1 } = this;
    return {
      width: (imgEl?.width ?? 0) * _scale,
      height: (imgEl?.height ?? 0) * _scale
    };
  }
  private getImageIndex(data: number, values: IDataItemImageValuesData[]) {
    let index = -1;
    // let last = Math.abs(values[0].value - data);
    // values.forEach((item, i) => {
    //   if (Math.abs(item.value - data) < last) {
    //     index = i;
    //     last = Math.abs(values[i].value - data);
    //   }
    // });
    for (let i = values.length - 1; i >= 0; i--) {
      const { value } = values[i];
      if (data >= value) {
        index = i;
        break;
      }
    }
    return index;
  }

  private getImageEl(index: number) {
    const { runtime, dataItem } = this;
    const { ref, hasInvalidValueImage } = dataItem as IDataItemImageValues;
    const imageArrayDataItem = runtime.dataItems[ref] as IImageArray;
    if (!imageArrayDataItem?.children?.length) return;

    const maxIndex = imageArrayDataItem.children.length - 1;
    const defaultIndex = hasInvalidValueImage ? maxIndex : 0;
    if (index > maxIndex || index < 0) index = defaultIndex;
    const { imgEl, src } = imageArrayDataItem.children[index] ?? {};
    return { imgEl, src };
  }

  private getImageParams() {
    const node = this.dataItem as IDataItemImageValues;
    const data = this.getDataSourceValue(node.source) as number;

    if (node.children?.length) {
      /**
       * 类似这种格式，value为图片index
       * <Param value="0" offsetX="0" offsetY="0" />
       */
      const index = this.getImageIndex(data, node.children);
      if (index < 0)
        return {
          index: -1,
          offsetX: 0,
          offsetY: 0
        };
      const { offsetX = 0, offsetY = 0 } = node.children[index];
      return {
        index,
        offsetX,
        offsetY
      };
    } else {
      const index = Math.floor(data);
      return {
        index,
        offsetX: 0,
        offsetY: 0
      };
    }
  }
  draw(): void {
    const { ctx, dataItem, _scale = 1, _alpha = 1 } = this;

    const { index, offsetX, offsetY } = this.getImageParams() ?? {};
    const { imgEl, src } = this.getImageEl(index) ?? {};
    if (!imgEl) return;

    const x = this.x + offsetX;
    const y = this.y + offsetY;

    const { rotation = 0 } = dataItem as IDataItemImageValues;
    // const { width, height } = imgEl;
    const width = imgEl.width * _scale;
    const height = imgEl.height * _scale;

    const { canvas: _canvas } = this.getOffscreen({
      width,
      height,
      init: (_, ctx) => {
        this.drawRecolorImage(ctx, imgEl, {
          x: 0,
          y: 0,
          w: width,
          h: height
        });
      },
      dirtyParmas: {
        src: src ?? ''
      }
    });

    // 透明度
    ctx.globalAlpha = _alpha;

    // 绘制
    ctx.save();
    const _rotation = toRadian(rotation);
    ctx.translate(x, y);
    if (this.rotatable) {
      ctx.rotate(_rotation);
    }
    ctx.translate(-x, -y);

    // 普通绘制
    // ctx.drawImage(_canvas, x, y);
    // 动画绘制
    this.drawAniFrame(_canvas);

    ctx.restore();
    ctx.globalAlpha = 1;

    this.setRuntimeData({
      width: width,
      height: height,
      rotation: 0
    });
  }
}
